import { ERecouvrement } from "./enum/recouvrement";

export class IBMRProfondeur {
    PInferieur01: ERecouvrement = ERecouvrement.Absent;
    PEntre01Et05: ERecouvrement = ERecouvrement.Absent;
    PEntre05Et1: ERecouvrement = ERecouvrement.Absent;
    PEntre1Et2: ERecouvrement = ERecouvrement.Absent;
    PSuperieur2: ERecouvrement = ERecouvrement.Absent;

    static mapFromJSON(json): IBMRProfondeur {
        const s = new IBMRProfondeur();

        s.PInferieur01 = json.pInferieur01;
        s.PEntre01Et05 = json.pEntre01Et05;
        s.PEntre05Et1 = json.pEntre05Et1;
        s.PEntre1Et2 = json.pEntre1Et2;
        s.PSuperieur2 = json.pSuperieur2;

        return s;
    }
}